<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-4">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <spinner v-if="showSpinner" />
            <form>
              <h2>Detalhes do usuário</h2>
              <div class="form-group">
                <span class="label label-primary pull-right"
                  >Saldo: {{ form.actualBalance | totalToCurrencyBR }}
                </span>
              </div>

              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome Completo</label>
                <input
                  type="text"
                  placeholder="João da Silva"
                  class="form-control"
                  v-model="form.fullName"
                />
              </div>

              <div class="form-group">
                <label>Telefone</label>
                <input
                  type="text"
                  placeholder="(21) 99887-6655"
                  v-mask="'(##) #####-####'"
                  class="form-control"
                  v-model="form.cellPhone"
                />
              </div>

              <div class="form-group">
                <label>E-Mail</label>
                <input
                  type="text"
                  placeholder="meuemail@gmail.com"
                  class="form-control"
                  v-model="form.email"
                />
              </div>

              <div class="form-group">
                <label>CPF</label>
                <input
                  type="text"
                  placeholder="987.654.321-00"
                  class="form-control"
                  v-mask="'###.###.###-##'"
                  v-model="form.cpf"
                />
              </div>
              <h3>Endereço</h3>
              <div class="form-group">
                <label>Cidade</label>
                <input
                  type="text"
                  placeholder="Informe uma senha"
                  class="form-control"
                  v-model="form.address.city"
                />
              </div>
              <div class="form-group">
                <label>Bairro</label>
                <input
                  type="text"
                  placeholder="Informe uma senha"
                  class="form-control"
                  v-model="form.address.neighborhood"
                />
              </div>
              <div class="form-group">
                <label>Rua</label>
                <input
                  type="text"
                  placeholder="Informe uma senha"
                  class="form-control"
                  v-model="form.address.street"
                />
              </div>
              <div class="form-group">
                <label>Complemento</label>
                <input
                  type="text"
                  placeholder="Informe uma senha"
                  class="form-control"
                  v-model="form.address.complement"
                />
              </div>
              <h3>Veículos</h3>
              <div>
                <table class="table table-hover table-mail">
                  <thead class="table-head">
                    <tr>
                      <th>Placa</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody class="table-list">
                    <tr
                      v-for="(vehicle, listIdx) in form.vehicleInfo"
                      :key="listIdx"
                    >
                      <td>{{ vehicle.licencePlate.toUpperCase() }}</td>
                      <td>
                        {{ vehicle.paidCredit >= 0 ? 'Regular' : 'Irregular' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <div class="row">
                <div class="col-lg-4">
                  <div class="input-group col-lg-12">
                    <button
                      class="btn btn-lg btn-primary"
                      type="button"
                      @click="updateConsumer"
                    >
                      <i class="fa fa-save"></i>
                      Salvar
                    </button>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="input-group col-lg-12">
                    <button
                      class="btn btn-lg btn-primary"
                      type="button"
                      @click="recoveryPassword"
                    >
                      <i class="fa fa-send"></i>
                      Resetar senha
                    </button>
                  </div>
                </div>
                <div class="col-lg-4" v-if="permissionToSuspend">
                  <div class="input-group col-lg-12">
                    <button
                      title="Troca a senha por uma senha temporária"
                      class="btn btn-lg btn-warning"
                      type="button"
                      @click="suspendConsumer"
                      v-if="!form.isSuspended"
                      :disabled="suspendButtonDisabled"
                    >
                      <i class="fa fa-lock"></i>
                      Suspender Conta
                    </button>
                    <button
                      title="Troca a senha por uma senha temporária"
                      class="btn btn-lg btn-warning"
                      type="button"
                      @click="removeSuspendedConsumer"
                      v-if="!!form.isSuspended"
                      :disabled="suspendButtonDisabled"
                    >
                      <i class="fa fa-lock"></i>
                      Remover Suspensão
                    </button>
                  </div>
                </div>
              </div>
              <br />
              <div v-if="hasBalanceToPay && permissionToPay">
                <div class="input-group">
                  <button
                    class="btn btn-lg btn-primary"
                    type="button"
                    @click="payDebits"
                  >
                    Quitar Débitos
                  </button>
                  <div class="form-group">
                    <span class="label label-danger pull-right"
                      >Débitos: R$ {{ totalDebits | totalToCurrencyBR }}
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <section class="col-lg-8">
        <section class="row">
          <div class="col-lg-12">
            <BalanceHistory />
          </div>
        </section>
        <section class="row">
          <div class="col-lg-12">
            <DebitHistory />
          </div>
        </section>
        <section class="row">
          <div class="col-lg-12">
            <LogHistory />
          </div>
        </section>
      </section>
    </div>

    <div
      class="modal inmodal"
      tabindex="-1"
      role="dialog"
      :style="{ display: displayModal ? 'block' : 'none' }"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            <i class="fa fa-lock modal-icon"></i>
            <h4 class="modal-title">Senha temporária criada</h4>
          </div>
          <div class="modal-body">
            <p class="text-center h2">
              {{ tempPassword }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" @click="closeModal">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mask } from 'vue-the-mask';
import BalanceHistory from './components/balance-history/BalanceHistory.vue';
import DebitHistory from './components/debit-history/DebitHistory.vue';
import LogHistory from './components/log-history/LogHistory.vue';
import Spinner from '@/components/Spinner';
export default {
  directives: { mask },
  components: {
    BalanceHistory,
    DebitHistory,
    LogHistory,
    Spinner,
  },
  data() {
    return {
      showSpinner: false,
      displayModal: false,
      suspendButtonDisabled: false,
      hasBalanceToPay: false,
      totalDebits: '',
      tempPassword: '',
      form: {
        id: '',
        fullName: '',
        cellPhone: '',
        email: '',
        cpf: '',
        actualBalance: '',
        vehicleInfo: [],
        address: {
          city: '',
          neighborhood: '',
          street: '',
          complement: '',
        },
        isSuspended: false,
      },
    };
  },
  computed: {
    permissionToSuspend() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'suspend-consumer',
        'SHOW',
      );
    },
    permissionToPay() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'consumer-info-pay-debits',
        'SHOW',
      );
    },
  },
  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
  },
  mounted() {
    this.loadConsumer();
    this.verifyWalletCreditToPayDebits();
  },
  methods: {
    closeModal() {
      this.displayModal = false;
    },
    async suspendConsumer() {
      this.showSpinner = true;
      this.suspendButtonDisabled = true;

      try {
        const payload = {
          suspensionMode: 'SUSPEND',
          consumerId: this.form.id,
        };
        const suspendResult = await this.$store.dispatch(
          'CONSUMER/ConsumerSuspension',
          payload,
        );
        this.loadConsumer();

        this.tempPassword = suspendResult.tempPassword;
        this.displayModal = !this.displayModal;
        this.$toasted.success('Conta suspensa com sucesso');
      } catch (error) {
        this.$toasted.error('Não foi possível suspender conta.');
      } finally {
        this.showSpinner = false;
        this.suspendButtonDisabled = false;
      }
    },
    async removeSuspendedConsumer() {
      this.showSpinner = true;
      this.suspendButtonDisabled = true;

      try {
        const payload = {
          suspensionMode: 'ENABLE',
          consumerId: this.form.id,
        };
        await this.$store.dispatch('CONSUMER/ConsumerSuspension', payload);
        this.loadConsumer();

        this.$toasted.success('Conta desbloqueada');
      } catch (error) {
        this.$toasted.error('Não foi possível desbloquear conta.');
      } finally {
        this.showSpinner = false;
        this.suspendButtonDisabled = false;
      }
    },
    async loadConsumer() {
      try {
        const userToken = this.$route.params.userToken;
        const payload = {
          userToken,
        };
        const { consumer } = await this.$store.dispatch(
          'CONSUMER/ConsumerInfo',
          payload,
        );

        this.form.id = consumer._id;
        this.form.fullName = consumer.fullName;
        this.form.cellPhone = consumer.cellPhone;
        this.form.email = consumer.email;
        this.form.cpf = consumer.cpf;
        this.form.actualBalance = consumer.actualBalance;
        this.form.vehicleInfo = consumer.vehicleInfo;
        this.form.isSuspended = consumer.isSuspended;

        if (consumer.address && consumer.address.city)
          this.form.address.city = consumer.address.city;
        if (consumer.address && consumer.address.neighborhood)
          this.form.address.neighborhood = consumer.address.neighborhood;
        if (consumer.address && consumer.address.street)
          this.form.address.street = consumer.address.street;
        if (consumer.address && consumer.address.complement)
          this.form.address.complement = consumer.address.complement;
      } catch (error) {
        this.$toasted.error('Não foi possível carregar dados.');
      }
    },
    async recoveryPassword() {
      try {
        this.showSpinner = true;
        await this.$store.dispatch('CONSUMER/RecoveryPassword', {
          email: this.form.email,
        });
        this.$toasted.success('E-mail para recuperação de senha enviado.');
      } catch (error) {
        this.$toasted.error(
          'Não foi possível enviar email de recuperação de senha.',
        );
      } finally {
        this.showSpinner = false;
      }
    },
    async updateConsumer() {
      try {
        const regxp = /[^A-Za-z0-9]+/gi;

        this.showSpinner = true;
        await this.$store.dispatch('CONSUMER/UpdateData', {
          email: this.form.email,
          fullName: this.form.fullName,
          cellPhone: this.form.cellPhone.replace(regxp, ''),
          cpf: this.form.cpf.replace(regxp, ''),
          address: {
            city: this.form.address.city,
            neighborhood: this.form.address.neighborhood,
            street: this.form.address.street,
            complement: this.form.address.complement,
          },
          userToken: this.$route.params.userToken,
        });
        this.$toasted.success('Dados atualizados.');
      } catch (error) {
        this.$toasted.error('Não foi possível atualizar os dados.');
      } finally {
        this.showSpinner = false;
      }
    },
    async verifyWalletCreditToPayDebits() {
      try {
        if (!this.permissionToPay) {
          return;
        }
        this.showSpinner = true;
        const { hasBalanceToPay, totalDebits } = await this.$store.dispatch(
          'CONSUMER/VerifyWalletCredit',
          {
            userToken: this.$route.params.userToken,
          },
        );

        this.hasBalanceToPay = hasBalanceToPay;
        this.totalDebits = totalDebits;
      } catch (error) {
        this.$toasted.error(
          'Não foi possível verificar saldo para pagar débitos',
        );
      } finally {
        this.showSpinner = false;
      }
    },
    async payDebits() {
      try {
        if (!this.permissionToPay) {
          return;
        }
        this.showSpinner = true;
        await this.$store.dispatch('CONSUMER/PaymentSet', {
          consumerToken: this.$route.params.userToken,
        });

        this.loadConsumer();
        this.verifyWalletCreditToPayDebits();
        await this.$refs.statementRef.loadConsumerStatement();
        this.$toasted.success('Débitos pagos!');
      } catch (error) {
        this.$toasted.error('Não foi possível pagar débitos');
      } finally {
        this.showSpinner = false;
      }
    },
  },
};
</script>
